import isMobile from 'ismobilejs'

export const page = document.querySelector('[data-body]')
export const header = document.querySelector('[data-header]')
export const mobile = isMobile().any
